<style scoped>
  .c-form_body .count p {
    text-align: right;
  }
</style>

<template>
    <div class="container" v-if="carts!=''&&errors.status">
        <div class="c-explain" :class="[TOTAL_PRICE <= 0 ? 'c-input_error' : null]">
            {{ TOTAL_PRICE > 0 ? messages.purchasable : messages.unpurchasable }}
        </div>

        <h3 class="p-cart__title">カートに入っている商品</h3>

        <div class="c-form c-form--sp">
            <div class="c-form_head">
                <div class="c-form_row">
                    <div class="c-form_col c-form_label name f-full">
                        商品
                    </div>
                    <div class="c-form_col c-form_label cycle">
                        お届け間隔
                    </div>
                    <div class="c-form_col c-form_label price">
                        単価(税込)
                    </div>
                    <div class="c-form_col c-form_label count">
                        1回のお届け数量
                    </div>
                    <div class="c-form_col c-form_label summary">
                        小計(税込)
                    </div>
                    <div class="c-form_col c-form_label command">
                    </div>
                </div>
            </div>

            <div class="c-form_body" v-loading="status.is_loading">
                <div class="c-form_row" v-for="cart in carts" :key="cart.id">
                    <div class="c-form_col name f-full">
                        <div class="c-form_col_inner p-cart__itemlist_item">
                            <!-- 商品 -->
                            <a class="iteminfo" :href="[getProductLink(cart)]">
                                <span class="img">
                                    <img :src="cart.image" />
                                </span>
                                <span class="detail">
                                    <span class="icon" :class="[cart.products_regular_pattern ? 'regular' : 'normal']">{{ getIconName(cart) }}</span>
                                    <span class="name">{{ cart[cart.relation].web_title }}</span>
                                </span>
                            </a>
                            <!-- 注意書き -->
                            <div class="comment" v-if="cart.products_regular_pattern">
                                <div v-html="cart.products_regular_pattern.products_regular_pattern_content.price_annotation"></div>
                            </div>
                            <div class="comment u-text--red" v-if="cart.alert">
                                {{ messages.purchaseable_limit }}
                            </div>
                        </div>
                    </div>
                    <div class="c-form_col cycle" v-if="cart.products_regular_pattern">
                        <div class="label is-hidden-desktop">配送間隔：</div>
                        <div class="c-form_col_inner">
                            <div class="c-input_select">
                                <select class="c-input c-input--select" v-model="cart.cycle">
                                    <option v-for="(m_cycle, i) in getRegularCycle(cart)" :key="i" :value="Number(m_cycle)">{{ regular_cycle_type[m_cycle] }}毎</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="c-form_col cycle is-hidden-mobile" v-else><div class="c-form_col_inner">ー</div></div>

                    <div class="c-form_col price">
                        <div class="label is-hidden-desktop">単価(税込)：</div>
                        <div class="c-form_col_inner">
                            <span>{{ getUnitPrice(cart) | delimiter }}円</span>
                        </div>
                    </div>

                    <div class="c-form_col count">
                        <div class="label is-hidden-desktop" v-if="cart.products_regular_pattern">1回のお届け数量：</div>
                        <div class="label is-hidden-desktop" v-else>数量：</div>
                        <div class="c-form_col_inner">
                            <div class="c-input_select">
                                <select class="c-input c-input--select" v-model="cart.quantity">
                                    <option v-for="quantity in cart.quantity_range" :value="quantity">{{ quantity }}</option>
                                </select>
                            </div>
                            <p class="u-text--gray8" v-if="cart.products_regular_pattern">/1回あたり</p>
                        </div>
                    </div>

                    <div class="c-form_col summary">
                        <div class="label is-hidden-desktop">小計(税込)：</div>
                            <div class="c-form_col_inner">
                                <span>{{ getUnitPrice(cart) * cart.quantity | delimiter }}円</span>
                                <br />
                                <span class="u-text--gray8" v-if="isRegularAlpha(cart.code.code)">(通常 {{ ALPHA_NORMAL_PRICE | delimiter }}円)</span>
                                <span class="u-text--gray8" v-else-if="isSasaVeitchii(cart.code.code)">(通常 {{ SASA_VEITCHII_NORMAL_PRICE | delimiter }}円)</span>
                                <span class="u-text--gray8" v-else-if="isGoodBacteria(cart.code.code)">(通常 {{ GOOD_BACTERIA_NORMAL_PRICE | delimiter }}円)</span>
                                <span class="u-text--gray8" v-else-if="isBeeCareRJ(cart.code.code)">(通常 {{ BEE_CARE_RJ_NORMAL_PRICE | delimiter }}円)</span>
                                <span class="u-text--gray8" v-else-if="cart.products_regular_pattern">(通常 {{ cart[cart.relation].product.price * cart.quantity | delimiter }}円)</span>
                                <span class="u-text--gray8" v-else-if="cart[cart.relation].price !== cart.price_origin">(通常 {{ cart.price_origin * cart.quantity | delimiter }}円)</span>
                                <div class="comment" v-if="cart.products_regular_pattern && cart.products_regular_pattern.is_regular_combination_discount">
                                    <div class="icon">
                                        <img src="/assets/image/icon-special-care-discount.png" alt="スペシャルケアセット割引適用" />
                                    </div>
                                    <div class="question">
                                        <a class="c-icon--question u-text--gray8 js-modalbox--open" modal-name="modalbox--specialcare_discount" href="#">スペシャルケアセット割引とは</a>
                                    </div>
                                </div>
                            </div>
                    </div>
                    <div class="c-form_col command">
                        <div class="c-form_col_inner">
                            <button class="c-btn c-btn--xxs c-btn--gray" @click="remove(cart)">削除</button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="c-form_foot">
                <div class="c-form_row">
                    <div class="c-form_col totalsummary f-full">
                        <div class="totalcount">
                            <div class="label">商品合計数量：</div>
                            <div class="value"><span>{{ QUANTITY }}</span>点</div>
                        </div>
                        <div class="totalprice">
                            <div class="label">商品合計金額：</div>
                            <div class="value"><span class="u-text--red">{{ TOTAL_PRICE | delimiter }}</span>円</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="c-btn-area">
            <!-- 長期休暇期間の営業に関するお知らせ -->
            <div v-if="news_images">
                <div v-for="news_image in news_images" style="text-align: center; margin-bottom: 20px;">
                    <img :src="news_image.img_path" :data-src="news_image.img_path" class="js-image-switch" style="max-width: 100%" />
                </div>
            </div>

            <!-- アップセルバナー -->
            <div v-if="upsells" style="text-align: center; margin-bottom: 20px;">
                <a href="#" :class="upsells.class" @click="upsell(upsells.id)">
                    <img :src="upsells.img_path" :data-src="upsells.img_path" class="js-image-switch" />
                </a>
                <div class="u-mt--xs u-text--red u-mb--xs" style="text-align: center;">※クリックで注文内容が切り替わります。数量にご注意ください。</div>
            </div>
            <ul>
                <li>
                    <a class="c-btn c-btn--lg c-btn--gray c-btn_shadow c-btn--back" href="/">お買い物を続ける</a>
                </li>
                <li>
                    <button
                        v-if="status.is_purchaseable"
                        class="c-btn c-btn--lg c-btn_shadow c-btn--next c-btn--orange"
                        @click="update">お会計はこちら
                    </button>
                </li>
            </ul>
        </div>
        <!-- 定期組合せ割引の説明ダイアログ -->
        <!-- c-modalbox -->
        <div id="modalbox--specialcare_discount" class="c-modalbox">
            <div class="header">
                スペシャルケアセット割引とは
            </div>
            <div class="content">
                エニストの化粧水、美容乳液、クリームの３商品をすべて定期購入された場合に適用される割引です。
            </div>
            <div class="close js-modalbox--close"><span>閉じる</span></div>
        </div>
        <!-- /c-modalbox -->
    </div>
    <div class="box shadow radius4 c-btn-area" v-else>
        <div class="explain">カート内に商品はありません。</div>
        <ul>
            <li>
                <a class="c-btn c-btn--lg c-btn--gray c-btn_shadow c-btn--back" href="/">お買い物を続ける</a>
            </li>
        </ul>
         <el-dialog
            :width="!status.is_device_pc ? '90%' : '50%'"
            :visible.sync="!status.has_error"
            :modalAppendToBody="false"
            @close="goTo">
                <span slot="title" class="el-dialog__title" style="white-space: pre-wrap">通信に失敗しました</span>
                <span style="white-space: pre-wrap">{{ errors.message }}</span>
                <span slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="status.has_error = !status.has_error">確認</el-button>
                </span>
        </el-dialog>
    </div>
</template>

<script>
    const store = require('../store/').default;
    const {ACTION} = require('../store/action-types');
    const {MUTATION} = require('../store/mutation-types');
    import ElementUI from 'element-ui'
    import locale from 'element-ui/lib/locale/lang/ja'
    import 'element-ui/lib/theme-chalk/index.css'
    import Common from '../../common/Common';

    Vue.use(ElementUI, {locale});
    import { Loading } from 'element-ui';

    export default {
        mixins: [Common],
        data: function() {
            return store.state
        },
        components: {
        },
        created: function () {
            store.commit(MUTATION.SET_IS_PURCHASEABLE, this.TOTAL_PRICE);
            store.commit(MUTATION.SET_HAS_ERROR);
        },
        methods: {
            remove: function(cart) {
                store.dispatch(ACTION.DELETE_CART, cart.id).then(() => {
                    if (this.carts.length > 0) {
                        location.reload();
                        location.hash = 'top';
                    }
                });
            },
            update: function() {
                this.status.is_loading = true;
                store.dispatch(ACTION.UPDATE_CART, {carts: this.carts, total_discount_price: this.total_discount_price}).then(() => {
                    if (this.response.status) {
                        window.location.href = this.checkout_url;
                    } else {
                        location.reload();
                        location.hash = 'top';
                    }
                });
            },
            upsell: function(upsell_id) {
                this.status.is_loading = true;
                store.dispatch(ACTION.UPSELL_CART, upsell_id).then(() => {
                    location.reload();
                    location.hash = 'top';
                });
            },
            changeQuantity: function() {
                let codes = this.setCodes(this.carts);
                if (Object.keys(codes).length > 0) {
                    this.checkCombination(codes).then(() => {
                        this.updateHeaderCart().then(() => {
                            location.reload();
                            location.hash = 'top';
                        });
                    });
                } else {
                    this.updateHeaderCart().then(() => {
                        location.reload();
                        location.hash = 'top';
                    });
                }
            },
            checkCombination: function(codes) {
                if (Object.keys(codes).length > 0) {
                    return store.dispatch(ACTION.CHECK_COMBINATION, codes).then(() => {
                        for (let cart of this.carts) {
                            cart[cart.relation].price = this.tmp_combination[cart.code.code].price;
                            cart.price_origin = this.tmp_combination[cart.code.code].price_origin;
                            if (cart.products_regular_pattern) {
                                // 定期組合せ割引適用中フラグ
                                cart.products_regular_pattern.is_regular_combination_discount = this.tmp_combination[cart.code.code].is_regular_combination_discount || false;
                                // 割引額
                                cart.products_regular_pattern.discount_price = this.tmp_combination[cart.code.code].discount_price || 0;
                            }
                        }
                        return true;
                    });
                }
                return true;
            },
            setCodes: function(carts) {
                let codes = {};
                for (let cart of carts) {
                    codes[cart.code.code] = cart.quantity;
                }
                return codes;
            },
            updateHeaderCart: function() {
                return store.dispatch(ACTION.UPDATE_CART, {carts: this.carts, total_discount_price: this.total_discount_price}).then(() => {
                    ObHelper.updateHeaderCart();
                    this.status.is_loading = false;
                    return true;
                });
                return true;
            },
            getIconName: function(cart) {
                if (cart.product) {
                    return '通常';
                } else if (cart.products_regular_pattern) {
                    return '定期';
                } else if (cart.set) {
                    if (cart.set.is_campaign == 1) {
                        return 'CP';
                    } else {
                        return 'セット';
                    }
                }
                return;
            },
            getProductLink: function(cart) {
                if (cart.product) {
                    return '/products/' + cart.code.code;
                } else if (cart.products_regular_pattern) {
                    return cart.products_regular_pattern.products_regular_pattern_content.url;
                } else if (cart.set) {
                    if (cart.set.is_campaign == 1) {
                        return '/mypage';
                    } else {
                        return cart.set.url || '/set';
                    }
                }
                return;
            },
            isRegularAlpha: function(code) {
                return this.alpha.regular_codes.indexOf(code) >= 0;
            },
            isSasaVeitchii: function(code) {
                return this.sasa_veitchii.regular_codes.indexOf(code) >= 0;
            },
            isGoodBacteria: function(code) {
                return this.good_bacteria.regular_codes.indexOf(code) >= 0;
            },
            isBeeCareRJ: function(code) {
                return this.bee_care_rj.regular_codes.indexOf(code) >= 0;
            },
            isPainPro: function(code) {
                return this.pain_pro.regular_codes.indexOf(code) >= 0;
            },
            isCognitivePower: function(code) {
                return this.cognitive_power.regular_codes.indexOf(code) >= 0;
            },
            getRegularCycle: function(cart) {
                let cycle = [];
                if (cart.products_regular_pattern) {
                    cycle = _.map(cart.products_regular_pattern.products_regular_patterns_month_cycle, 'days');
                }
                return cycle;
            },
            getUnitPrice: function(cart) {
                let price = cart[cart.relation].price;
                if (cart.products_regular_pattern) {
                    price -= cart.products_regular_pattern.discount_price;
                }
                return price;
            },
            goTo: function () {
                // リダイレクト
                if (this.errors.redirect) {
                    window.location.href = this.errors.redirect;
                }
            }
        },
        filters: {
            delimiter: function(value){
                return Number.isNaN(value) ? '計算中 ' : value.toLocaleString();
            }
        },
        computed: {
            QUANTITY: function(){
                let carts = this.carts;
                return carts.reduce((a, b) => a + b.quantity, 0);
            },
            TOTAL_PRICE: function() {
                let carts = this.carts;
                return carts.reduce((a, b) => a + (b[b.relation].price * b.quantity), this.total_discount_price * -1);
            },
            ALPHA_NORMAL_PRICE: function () {
                let carts = this.carts;
                let sum = 0;
                for (let cart of carts) {
                    if (this.isRegularAlpha(cart.code.code)) {
                        if (cart.code.code == this.front_alpah_const.REGULAR_ALPHA_CODE_1) {
                            // 通常商品で計算
                            sum = cart[cart.relation].product.price * cart.quantity;
                        } else {
                            // R51で計算
                            sum = this.alpha.regular_patterns.R51.price * cart.quantity;
                        }
                    }
                }
                return sum;
            },
            SASA_VEITCHII_NORMAL_PRICE: function () {
                let carts = this.carts;
                let sum = 0;
                for (let cart of carts) {
                    if (this.isSasaVeitchii(cart.code.code)) {
                        // 通常商品で計算
                        sum = cart[cart.relation].product.price * cart.quantity;
                    }
                }
                return sum;
            },
            GOOD_BACTERIA_NORMAL_PRICE: function () {
                let carts = this.carts;
                let sum = 0;
                for (let cart of carts) {
                    if (this.isGoodBacteria(cart.code.code)) {
                        // 通常商品で計算
                        sum = cart[cart.relation].product.price * cart.quantity;
                    }
                }
                return sum;
            },
            BEE_CARE_RJ_NORMAL_PRICE: function () {
                let carts = this.carts;
                let sum = 0;
                for (let cart of carts) {
                    if (this.isBeeCareRJ(cart.code.code)) {
                        // 通常商品で計算
                        sum = cart[cart.relation].product.price * cart.quantity;
                    }
                }
                return sum;
            },
            PAIN_PRO_NORMAL_PRICE: function () {
                let carts = this.carts;
                let sum = 0;
                for (let cart of carts) {
                    if (this.isPainPro(cart.code.code)) {
                        // 通常商品で計算
                        sum = cart[cart.relation].product.price * cart.quantity;
                    }
                }
                return sum;
            },
            COGNITIVE_POWER_NORMAL_PRICE: function () {
                let carts = this.carts;
                let sum = 0;
                for (let cart of carts) {
                    if (this.isCognitivePower(cart.code.code)) {
                        sum = cart[cart.relation].product.price * cart.quantity;
                    }
                }
                return sum;
            }
        },
        watch: {
            carts: {
                handler: function (val) {
                    this.status.is_loading = true;
                    for (let k of Object.keys(val)) {

                        let quantity = val[k].quantity;
                        let upper_limit = Math.max.apply(null, val[k].quantity_range);
                        let relation = val[k].relation;
                        this.carts[k].alert = upper_limit < quantity;

                        if (this.isRegularAlpha(val[k].code.code)) {
                            // 定期アルファだったら
                            for (let code of this.alpha.regular_codes) {
                                if (quantity >= this.alpha.regular_patterns[code].min_quantity
                                    && quantity <= this.alpha.regular_patterns[code].max_quantity
                                ) {
                                    this.carts[k].code_id = this.alpha.regular_patterns[code].code.id;
                                    this.carts[k].code = this.alpha.regular_patterns[code].code;
                                    this.carts[k][relation] = this.alpha.regular_patterns[code];
                                    // サイクル
                                    let regular_cycle = this.getRegularCycle(val[k]);
                                    this.carts[k].cycle = regular_cycle.find((el) => {return el == val[k].cycle}) === void 0 ? regular_cycle[0] : val[k].cycle;
                                }
                            }
                        } else if (this.isSasaVeitchii(val[k].code.code)) {
                            // 定期熊笹プレミアムエキスだったら
                            for (let code of this.sasa_veitchii.regular_codes) {
                                if (quantity >= this.sasa_veitchii.regular_patterns[code].min_quantity
                                    && quantity <= this.sasa_veitchii.regular_patterns[code].max_quantity
                                ) {
                                    this.carts[k].code_id = this.sasa_veitchii.regular_patterns[code].code.id;
                                    this.carts[k].code = this.sasa_veitchii.regular_patterns[code].code;
                                    this.carts[k][relation] = this.sasa_veitchii.regular_patterns[code];
                                    // サイクル
                                    let regular_cycle = this.getRegularCycle(val[k]);
                                    this.carts[k].cycle = regular_cycle.find((el) => {return el == val[k].cycle}) === void 0 ? regular_cycle[0] : val[k].cycle;
                                }
                            }
                        } else if (this.isGoodBacteria(val[k].code.code)) {
                            // 定期毎日善玉菌だったら
                            for (let code of this.good_bacteria.regular_codes) {
                                if (quantity >= this.good_bacteria.regular_patterns[code].min_quantity
                                    && quantity <= this.good_bacteria.regular_patterns[code].max_quantity
                                ) {
                                    this.carts[k].code_id = this.good_bacteria.regular_patterns[code].code.id;
                                    this.carts[k].code = this.good_bacteria.regular_patterns[code].code;
                                    this.carts[k][relation] = this.good_bacteria.regular_patterns[code];
                                    // サイクル
                                    let regular_cycle = this.getRegularCycle(val[k]);
                                    this.carts[k].cycle = regular_cycle.find((el) => {return el == val[k].cycle}) === void 0 ? regular_cycle[0] : val[k].cycle;
                                }
                            }
                        } else if (this.isBeeCareRJ(val[k].code.code)) {
                            // 定期ビーケア RJだったら
                            for (let code of this.bee_care_rj.regular_codes) {
                                if (quantity >= this.bee_care_rj.regular_patterns[code].min_quantity
                                    && quantity <= this.bee_care_rj.regular_patterns[code].max_quantity
                                ) {
                                    this.carts[k].code_id = this.bee_care_rj.regular_patterns[code].code.id;
                                    this.carts[k].code = this.bee_care_rj.regular_patterns[code].code;
                                    this.carts[k][relation] = this.bee_care_rj.regular_patterns[code];
                                    // サイクル
                                    let regular_cycle = this.getRegularCycle(val[k]);
                                    this.carts[k].cycle = regular_cycle.find((el) => {return el == val[k].cycle}) === void 0 ? regular_cycle[0] : val[k].cycle;
                                }
                            }
                        } else if (this.isPainPro(val[k].code.code)) {
                            // 定期PAIN PROだったら
                            for (let code of this.pain_pro.regular_codes) {
                                if (quantity >= this.pain_pro.regular_patterns[code].min_quantity
                                    && quantity <= this.pain_pro.regular_patterns[code].max_quantity
                                ) {
                                    this.carts[k].code_id = this.pain_pro.regular_patterns[code].code.id;
                                    this.carts[k].code = this.pain_pro.regular_patterns[code].code;
                                    this.carts[k][relation] = this.pain_pro.regular_patterns[code];
                                    // サイクル
                                    let regular_cycle = this.getRegularCycle(val[k]);
                                    this.carts[k].cycle = regular_cycle.find((el) => {return el == val[k].cycle}) === void 0 ? regular_cycle[0] : val[k].cycle;
                                }
                            }
                        } else if (this.isCognitivePower(val[k].code.code)) {
                            // 定期認知力だったら
                            for (let code of this.cognitive_power.regular_codes) {
                                if (quantity >= this.cognitive_power.regular_patterns[code].min_quantity
                                    && quantity <= this.cognitive_power.regular_patterns[code].max_quantity
                                ) {
                                    this.carts[k].code_id = this.cognitive_power.regular_patterns[code].code.id;
                                    this.carts[k].code = this.cognitive_power.regular_patterns[code].code;
                                    this.carts[k][relation] = this.cognitive_power.regular_patterns[code];
                                    // サイクル
                                    let regular_cycle = this.getRegularCycle(val[k]);
                                    this.carts[k].cycle = regular_cycle.find((el) => {return el == val[k].cycle}) === void 0 ? regular_cycle[0] : val[k].cycle;
                                }
                            }
                        }
                    }
                    this.changeQuantity();
                },
                deep : true
            },
            'status.is_loading': function () {
                store.commit(MUTATION.SET_IS_PURCHASEABLE, this.TOTAL_PRICE);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/front/cart/components/Cart.vue